import axios from "axios";
import { getGatewayIdToken } from "./gatewaySession";

const shareLinkApiBaseUrl = import.meta.env.VITE_SHARELINK_API;

const shareLinkApi = axios.create({
  baseURL: shareLinkApiBaseUrl,
});

shareLinkApi.interceptors.request.use(async (config) => {
  if ((config.method ?? "get").toLowerCase() === "get" && config.url === "/api/gift-table/find-by-share-link") {
    config.headers.delete("Authorization");
    return config;
  }
  config.headers.Authorization = `Bearer ${await getGatewayIdToken()}`;
  return config;
});

export interface ShareLinkResponse {
  shareLink: string;
  giftTableID: string;
}

export interface GetGiftTableBySharelinkResponse {
  giftTableID: string;
}

export interface CheckAliasResponse {
  available: boolean;
}

export const getShareLink = async (
  giftTableID: string
): Promise<ShareLinkResponse> => {
  try {
    const response = await shareLinkApi.get<ShareLinkResponse>(
      "/api/gift-table/share-link",
      {
        params: { id: giftTableID },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching share link", error);
    throw new Error("Failed to fetch share link");
  }
};

export const updateAlias = async (
  id: string,
  alias: string
): Promise<ShareLinkResponse> => {
  try {
    const response = await shareLinkApi.post<ShareLinkResponse>(
      "/api/gift-table/update-alias",
      { id, alias }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating alias", error);
    throw new Error("Failed to update alias");
  }
};

export const getGiftTableByShareLink = async (
  value: string
): Promise<GetGiftTableBySharelinkResponse> => {
  try {
    const response = await shareLinkApi.get<GetGiftTableBySharelinkResponse>(
      "/api/gift-table/find-by-share-link",
      {
        params: { value },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching gift table by share link", error);
    throw new Error("Failed to fetch gift table ID");
  }
};

export const checkAliasAvailability = async (
  alias: string
): Promise<CheckAliasResponse> => {
  try {
    const response = await shareLinkApi.get<CheckAliasResponse>(
      "/api/gift-table/check-alias",
      {
        params: { alias },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error checking alias availability", error);
    throw new Error("Failed to check alias availability");
  }
};
